import { Directive, ElementRef, HostListener } from '@angular/core';

/** Directive para manipular a ativação de um tr em tables */
@Directive({
    selector: '[sgtTableTrActive]'
})
export class TableTrActiveDirective {

    constructor(private el: ElementRef) { }

    @HostListener('focus', ['$event']) onFocus($event) {
        setTimeout(() => jQuery(this.el.nativeElement)?.closest('tr')?.addClass('active'), 0);
    }

    @HostListener('focusout', ['$event']) onFocusout($event) {
        setTimeout(() => jQuery(this.el.nativeElement)?.closest('tr')?.removeClass('active'), 0);
    }
}
